<script setup lang="ts">
const colorMode = useColorMode()

const color = computed(() => colorMode.value === 'dark' ? '#09090b' : 'white')

useHead({
  meta: [
    { name: 'viewport', content: 'width=device-width, initial-scale=1' },
    { key: 'theme-color', name: 'theme-color', content: color }
  ],
  link: [
    {
      rel: 'icon',
      type: 'image/webp', // Précise bien le format ici
      href: '/favicon.webp'
    },
    {
      rel: 'apple-touch-icon',
      href: '/apple-touch-icon.png'
    }
  ],
  htmlAttrs: {
    lang: 'fr' // Change 'en' par 'fr' pour correspondre à ton contenu
  }
})

useSeoMeta({
  // Supprime l'image Nuxt par défaut et utilise ton logo ou une image de ton choix
  ogImage: '/logo.webp',
  twitterCard: 'summary_large_image',
  ogType: 'website',
  ogLocale: 'fr_FR'
})
</script>

<template>
  <UApp :toaster="{ expand: false }">
    <AppHeader />

    <UMain>
      <NuxtPage />
    </UMain>

    <AppFooter />
  </UApp>
</template>
